import "../../exam/components/Layout/Footer.css";
import Button from "../../../../shared/components/Button/Button";

const ExerciseFooter = ({
  isFirstQuestion,
  isLastQuestion,
  hasAnswer,
  busy,
  onPrevious,
  onMarkReview,
  onSaveNext,
}) => {
  return (
    <div className="footer-container">
      <div className="footer-left">
        <Button
          title="Previous"
          variant="outlined"
          color="primary"
          className="footer-btn outlined-btn"
          onClick={onPrevious}
          disabled={isFirstQuestion || busy}
        />
        <Button
          title="Mark for Review"
          variant="outlined"
          color="primary"
          className="footer-btn outlined-btn"
          onClick={onMarkReview}
          disabled={busy}
        />
      </div>

      <div className="footer-right">
        <Button
          title={isLastQuestion ? "Save" : "Save & Next"}
          variant="contained"
          color="error"
          className="footer-btn contained-error"
          onClick={onSaveNext}
          disabled={busy || !hasAnswer}
        />
      </div>
    </div>
  );
};

export default ExerciseFooter;
